import React from 'react'
import kebabCase from 'lodash.kebabcase'
import clsx from 'clsx'
import { Image } from '@/components/atoms/Image/Image'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import { TrustedByTypes } from './types'

export function TrustedBySection({ pageContent, instance, ...props }: TrustedByTypes) {
  const { content } = pageContent?.blok || instance || {}
  const { title, subtitle, images } = content || props

  return (
    <section
      className="flex flex-col text-center p-24 tablet:py-64 max-w-screen-desktop mx-auto laptop:px-90 "
      id={kebabCase(title)}
    >
      <h2 className=" font-poppins font-bold text-headingM-mobile mb-16 netbook:text-headingM text-text-dark-900">
        {title}
      </h2>
      {subtitle && <Paragraph className="mb-16 netbook:mb-64 text-text-dark-600">{subtitle}</Paragraph>}
      <div
        className={clsx(
          'grid grid-cols-2 netbook:grid-cols-4 grid-rows-2 netbook:gap-24 gap-y-16 gap-x-20 netbook:gap-x-24 netbook:w-10/12 mx-auto *:place-self-center',
          {
            'netbook:grid-cols-5': images.length % 5 === 0,
            'netbook:grid-rows-1': images.length <= 5
          }
        )}
      >
        {images.map((img) =>
          img.link && img.link.cached_url ? (
            <CustomLink
              {...img.link}
              key={img._uid}
              link_url={img.link}
              new_tab
              is_external={img.link.linktype === 'url'}
              className={clsx({ 'hidden netbook:block': img.show_mobile === false })}
            >
              <Image
                fixed
                data={img.image}
                width={200}
                height={100}
                showMobile={img.show_mobile}
                className="w-auto m-24 h-[85px] max-h-[85px]"
                imgClassName="h-3/4 w-80 tablet:h-auto tablet:w-auto mr-24 tablet:mr-0 "
              />
            </CustomLink>
          ) : (
            <Image
              fixed
              data={img.image}
              key={img._uid}
              imgClassName="h-3/4 w-80 tablet:h-auto tablet:w-auto mr-24 tablet:mr-0 "
              width={200}
              height={100}
              className={clsx('w-auto m-24 max-h-[85px]', { 'hidden netbook:block': img.show_mobile === false })}
              showMobile={img.show_mobile}
            />
          )
        )}
      </div>
    </section>
  )
}
